module.exports = __webpack_public_path__ + "static/dr_lynne_harris-4719c37ca1ef438b98b8cb70a986f952.jpg";